import React from "react";
import ReactDOM from "react-dom";
import App from "src/App";

import "src/styles/Toolbox.css";
import "src/styles/ContextMenu.css";
import "src/styles/Global.css";

ReactDOM.render(<App />, document.getElementById("root"));
